import Vue from 'vue';

Vue.component('pwp-promotion-report-index', () =>
    import(/* webpackChunkName: 'pwp-promotion-report-index' */ './pwp-promotion-report-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/pwp-promotion/index.js